import React from 'react';
export function withSection(WrappedComponent) {
  var ComponentWithSection = function ComponentWithSection(props) {
    var prefix = props.prefix,
        title = props.title,
        subtitle = props.subtitle,
        trans = props.trans;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-profile-wrap")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-profile-title")
    }, trans(title)), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-profile-sub-title")
    }, trans(subtitle)), /*#__PURE__*/React.createElement(WrappedComponent, props));
  };

  return ComponentWithSection;
}